module.exports = __webpack_public_path__ + "static/media/napolitanohomes.08a3b3de.png";